import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import type { OrgResponse } from "@bw/shared/types/generated";

export function OrgLaunchReadinessPanel({ org }: { org: OrgResponse }) {
  const blockers = org.approval_blockers ?? [];
  const status = org.can_approve
    ? "Ready"
    : `${blockers.length} ${blockers.length === 1 ? "blocker" : "blockers"}`;

  return (
    <Paper
      component="section"
      aria-labelledby="launch-readiness-heading"
      variant="outlined"
      sx={{ p: { xs: 2, md: 2.5 } }}
    >
      <Stack spacing={1.5}>
        <Stack
          direction="row"
          spacing={2}
          sx={{ alignItems: "center", justifyContent: "space-between" }}
        >
          <Typography
            id="launch-readiness-heading"
            component="h2"
            variant="h6"
            sx={{ fontWeight: 700 }}
          >
            Launch Readiness
          </Typography>
          <Chip
            size="small"
            color={org.can_approve ? "success" : "warning"}
            variant="outlined"
            label={status}
          />
        </Stack>

        {blockers.length > 0 ? (
          <List disablePadding>
            {blockers.map((blocker, index) => (
              <ListItem
                key={`${index}-${blocker}`}
                divider={index < blockers.length - 1}
                disableGutters
                sx={{ py: 1 }}
              >
                <Typography variant="body2">{blocker}</Typography>
              </ListItem>
            ))}
          </List>
        ) : (
          <Box>
            <Typography color="text.secondary" variant="body2">
              {org.can_approve
                ? "The backend allows launch approval."
                : "Launch approval is not currently available."}
            </Typography>
          </Box>
        )}
      </Stack>
    </Paper>
  );
}
